import React from 'react';
import moment from "moment";
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import mdEntityService from 'core/metamodel/mdEntityService';
import {createForm} from 'core/form/createForm';
import {Validate} from 'core/form/validate';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import {action, observable} from "mobx";
import {FormProps} from "core/form/formUtils";
import {observer} from "mobx-react";
import {DialogAncestor, DialogProps} from "core/common/page/dialogAncestor";
import {ShipmentRepackagingResource} from "shipment/shipmentDomain";
import NumberField from "core/components/fields/numberField";
import {Min, NumberFormat} from "core/form/rules";
import {formatDate, stripTime} from "core/common/utils/dateUtils";
import shipmentService from "shipment/shipmentService";
import securityService from "core/security/securityService";
import {PERMISSION, SECURABLE} from "core/metamodel/metaConstant";


/* ************************************************************************************************
 * ***********   DIALOG  *************************************************************
 * ********************************************************************************************** */



@observer
export class ShipmentRepackagingResourceDialog extends DialogAncestor<DialogProps, undefined, string> {


  @observable toolbarDate: Date;
  @observable resource: ShipmentRepackagingResource;

  @action open(resolve: any, reject: any, toolbarDate: Date, resource: ShipmentRepackagingResource) {

    console.log('ShipmentRepackagingResourceDialog: Opening dialog for toolbarDate', toolbarDate);

    this.resource = resource;
    this.resolve = resolve;
    this.reject = reject;
    this.dialogOpen = true;
    this.toolbarDate = toolbarDate;


  }


  @action ok = () => {
    this.$errors = [];
    let form = this.resource.getForm("ShipmentRepackagingResourceDialogForm");

    form.validateForm(this.resource, this.$errors);

    if (!this.$errors.length) {
      shipmentService.saveShipmentRepackagingResource(this.resource)
        .then(() => {
          this.dialogOpen = false;
          this.resolve("OK");
        }, error => {
          this.$errors = error.getMessages();
        });

    }
  };

  @action cancel = () => {
    this.dialogOpen = false;
    this.reject("cancel");
  };


  render() {

    if (!(this.dialogOpen)) return null;

    console.log('MultiUpdateDialog: rendering dialog');


    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={this.cancel}
      />,
      <FlatButton
        label="Save"
        disabled={moment(this.resource.workDate).isBefore(stripTime(new Date()))}
        secondary
        onClick={this.ok}
      />,
    ];

    return (
      <Dialog
        title={`Norma na ${formatDate(this.toolbarDate)}`}
        actions={actions}
        modal={true}
        open={this.dialogOpen}
        contentStyle={{width: '60%', maxWidth: 'none'}}
        bodyStyle={{overflow: 'visible'}}
      >

        <ErrorComp messages={this.$errors}/>

        {(this.resource) ? (
          <ShipmentRepackagingResourceDialogForm entities={mdEntityService.entityMap} entity={mdEntityService.getEntity("ShipmentRepackagingResource")} dataObject={this.resource} rootObject={this.resource} toolbarDate={this.toolbarDate}/>
        ) : null}

      </Dialog>
    );
  }

}


/* ************************************************************************************************
 * ***********   FORM  *************************************************************
 * ********************************************************************************************** */


interface  ShipmentRepackagingResourceDialogFormProps extends FormProps<ShipmentRepackagingResource, ShipmentRepackagingResource> {
  toolbarDate?: Date;
}

@createForm({
  formName: 'ShipmentRepackagingResourceDialogForm',
  fields: [{
    name: 'availableResources',
    validators: ['IsNumber', 'IsRequired'],
  }, {
    name: 'dailyPalleteNorm',
    validators: ['IsNumber', 'IsRequired'],
  }]
}, () => <noscript/>)
@observer
class ShipmentRepackagingResourceDialogForm extends React.Component<ShipmentRepackagingResourceDialogFormProps> {


  render() {

    let {dataObject, rootObject, entities, index, form, toolbarDate} = this.props;
    let {availableResources, dailyPalleteNorm} = form.fields;

    let hasRightForNorm = securityService.hasRight(SECURABLE.shipmentRepackagingSetNorm.name, PERMISSION.Execute);

    return (

      <div style={{display: 'flex'}}>


        <div style={{marginRight: 10}}>
          <div>
            <NumberField {...availableResources.props} />
            <Validate field={availableResources} value={availableResources.props.value}>
              <NumberFormat precision={10} scale={2}/>
              <Min min={0}/>
            </Validate>
          </div>
        </div>

        <div style={{marginRight: 10}}>
          <div>
            <NumberField {...dailyPalleteNorm.props} disabled={!hasRightForNorm} />
            <Validate field={dailyPalleteNorm} value={dailyPalleteNorm.props.value}>
              <NumberFormat precision={4} scale={0}/>
              <Min min={0}/>
            </Validate>
          </div>
        </div>


      </div>
    );
  }



}



// WEBPACK FOOTER //
// ./src/shipment/component/shipmentRepackagingResourceDialog.tsx